import React from "react";
import moment from "moment";
import { Dialog, DialogContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DialogTitle } from "../../../components/Dialog/NewNote";
import Table from "../../../components/DetailsTable";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "28px",
    marginBottom: "0px",
    fontWeight: "bold",
    color: "#0C2945",
    fontFamily: "Roboto Condensed",
  },
  message: {
    margin: "0 0 20px",
    color: "#252733",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
}));

const EVENT_TYPE_LABELS = {
  login_success: "Login successful",
  login_failure: "Login failed",
};

const REASON_CODE_LABELS = {
  token_expired: "Login link expired",
  logout: "Logout",
  demographic_mismatch: "Wrong credential entered",
};

const formatTimestamp = (value) =>
  value
    ? `${moment(value).format("MM-DD-YYYY")} ${moment(value).format("LTS")}`
    : "-";

const formatEventType = (eventType) => {
  if (!eventType) return "-";
  if (EVENT_TYPE_LABELS[eventType]) return EVENT_TYPE_LABELS[eventType];
  return eventType
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const formatReason = (event) => {
  const failed =
    event?.event_type === "login_failure" || event?.result === "failure";
  if (!failed || !event?.reason_code) return "-";
  return (
    REASON_CODE_LABELS[event.reason_code] ||
    event.reason_code
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
};

const eventColumns = [
  {
    key: "created",
    name: "Timestamp",
    displayCell: (value) => formatTimestamp(value),
  },
  {
    key: "event_type",
    name: "Event Type",
    displayCell: (value) => formatEventType(value),
  },
  {
    key: "reason_code",
    name: "Reason",
    displayCell: (value, row) => formatReason(row),
  },
];

const PatientActivityEventsModal = ({ activity, onClose }) => {
  const classes = useStyles();
  const events = [...(activity?.events || [])].sort(
    (a, b) => new Date(b.created) - new Date(a.created)
  );

  return (
    <Dialog
      open={Boolean(activity)}
      aria-labelledby="patient-activity-events-title"
      maxWidth="md"
      fullWidth
      onClose={onClose}
    >
      <DialogTitle id="patient-activity-events-title" onClose={onClose}>
        <p className={classes.title}>Activity</p>
      </DialogTitle>
      <DialogContent style={{ minHeight: "320px", paddingBottom: "24px" }}>
        <p className={classes.message}>{activity?.message || "-"}</p>
        <Table
          columns={eventColumns}
          rows={events}
          isLoadingRow={false}
          isPaginated={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PatientActivityEventsModal;
